﻿/*
 * File per la definizione dei Service Angular, ovvero oggetti che espongono funzionalita' condivise tra diversi Controller:
 * https://code.angularjs.org/1.5.8/docs/guide/services
 */
define([
    'angular'
],
    function (angular) {

        var networkServices = angular.module('networkServices', []);

        //log eccezioni
        networkServices.factory('$exceptionHandler', ['$injector', function ($injector) {
            //			['$log', 'MessageService',  /*'logErrorsToBackend',*/ function($log, MessageService  /*,logErrorsToBackend*/) {

            var $log, MessageService;

            return function myExceptionHandler(exception, cause) {
                $log = $log || $injector.get('$log');
                MessageService = MessageService || $injector.get('MessageService');

                //logErrorsToBackend(exception, cause);
                $log.warn(exception, cause);
                MessageService.addSystemMessages(["Si è verificato un errore"]);
                MessageService.showMessages();
            };
        }]);

        networkServices.factory('StatusCodeInterceptorService', ['$q', '$window', '$location', 'CONSTANTS', '$log', 'MessageService', 'BroadcastService', StatusCodeInterceptorService]);

        /*
         * Intercetta gli status code HTTP ed esegue le redirect in funzione del codice di ritorno
         */
        function StatusCodeInterceptorService($q, $window, $location, CONSTANTS, $log, MessageService, BroadcastService) {
            var parseMessages = function (response) {
                try {
                    var data = null;
                    if (response !== undefined && response !== null) {
                        data = response.data;
                    }
                    if (data !== undefined && data !== null) {
                        //se la response contiene messaggi li notifichiamo ai controller (il reset rimane comunque applicativo).
                        if (data.messages !== undefined && data.messages !== null) {
                            $log.log("Aggiunta messages da interceptor");
                            $log.log(data.messages);
                            MessageService.setMessages(data.messages);
                            MessageService.showMessages();

                            if (MessageService.hasSecurityError()) {
                                BroadcastService.securityError();
                            }
                        }
                    }
                } catch (e) {
                    $log.log(e);
                    MessageService.singleMessageErrors("Si e' verificato un errore nella lettura dei dati dal server");
                }
            };

            var redirectApplicativo = function (response) {
                var data = null;
                if (response !== undefined && response !== null) {
                    data = response.data;
                }
                if (data && data.codiceErrore !== undefined) {
                    switch (data.codiceErrore) {
                        case "01":
                            $location.path("/home");
                            break;
                        default:
                            break;
                    }
                }
            };

            return {
                'request': function (config) {

                    //nel keepalive no spinner
                    if (config.data && config.data.isKeepAlive)
                        return config;
                    //spinner
                    var id = config.url;
                    BroadcastService.startJob(id);

                    return config;
                },
                'requestError': function (rejection) {
                    return $q.reject(rejection);
                },
                'response': function (response) {


                    //nel keepalive no spinner
                    if (response.status == 202)
                        return response;
                    //spinner
                    var id = response.config.url;
                    BroadcastService.endJob(id);

                    var data = null;
                    if (response != undefined && response != null) {
                        data = response.data;
                    }
                    parseMessages(response);

                    //errori applicativi codificati
                    redirectApplicativo(response);

                    return response;
                },
                'responseError': function (response) {
                    var status = response.status;

                    //aggiunta messages
                    parseMessages(response);

                    //errori applicativi codificati
                    redirectApplicativo(response);


                    //spinner
                    var id = response.config.url;
                    BroadcastService.endJob(id);

                    switch (status) {
                        /*
                         * In caso di codice -1 (il server non risponde), 0 (non parte la chiamata Ajax dal browser) o 404,
                         * si rimanda sulla pagina di errore
                         */
                        case -1:
                        case 0:
                        case 404:
                            $window.location.href = CONSTANTS["404_PAGE"];
                            break;
                        /*
                         * In caso di codice 401 o 403, si rimanda sulla pagina di login
                         */
                        case 401:
                            $window.location.href = CONSTANTS["401_PAGE"];
                            break;
                        case 400:
                            break;
                        case 403:
                            $window.location.href = CONSTANTS["403_PAGE"];
                            break;
                        case 500:
                        case 501:
                        case 302:
                            $window.location.href = CONSTANTS["ERROR_PAGE"];
                            break;
                        default:
                            break;
                    }
                    return $q.reject(response);
                }
            };
        };

        return networkServices;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/services/network-services.js
// module id = 45
// module chunks = 1